export { AddEditInventory } from './AddEditInventory.main';
